define(['angular'], function(angular) {

var m = require('am');

m.service('$localStorage', ['$window', function($window) {
  var storage = $window.localStorage;
  return {
    get: function(key) {
      return angular.fromJson(storage.getItem(key));
    },
    set: function(key, value) {
      return storage.setItem(key, angular.toJson(value));
    },
    remove: function(key) {
      storage.removeItem(key);
    }
  };
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/LocalStorage.js
 **/